import { cn } from "@gymflow/helpers";
import { Field, FieldProps, FormikProps } from "formik";

import { OptionType } from "../base/components/OptionsList/components/OptionItem";
import { LocationsSearchInput } from "../base/LocationsSearchInput";
import { ErrorMessage } from "../ErrorMessage";
import { Path } from "./types";

export type LocationsSearchInputOptionType = OptionType<{
  id: string;
  name: string;
}>;

export type FormLocationsSearchInputProps<T> = {
  name: Path<T>;
  className?: string;
  label?: string;
  placeholder?: string;
  isMulti?: boolean;
  withImageByDefault?: boolean;
  dropPosition?: "top" | "bottom";
  isRequired?: boolean;
};

export const FormLocationsSearchInput = <T,>({
  name,
  className,
  ...props
}: FormLocationsSearchInputProps<T>) => (
  <Field name={name}>
    {({
      field,
      form: { setFieldValue },
      meta: { touched, error },
    }: FieldProps<LocationsSearchInputOptionType, FormikProps<T>>) => {
      const isError = touched && error;
      return (
        <div className="flex flex-col gap-1.5">
          <LocationsSearchInput
            {...props}
            value={
              Array.isArray(field.value)
                ? field.value
                : field.value
                  ? [field.value]
                  : []
            }
            onChange={(selected) => setFieldValue(String(name), selected)}
            className={cn(
              className,
              isError && "outline-error-300 border-error-200",
            )}
          />
          {isError && <ErrorMessage text={error} />}
        </div>
      );
    }}
  </Field>
);
